import { Color } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const NudgeNextStepIcon = createSvgIcon(
  'NudgeNextStepIcon',
  <>
    <circle cx="16" cy="16.5" r="16" fill={Color.Silver200} />
    <path
      d="M16 8.5L14.59 9.91L20.17 15.5H8V17.5H20.17L14.59 23.09L16 24.5L24 16.5L16 8.5Z"
      fill={Color.Dark500}
    />
  </>,
  { viewBox: '0 0 32 33', style: { height: '32px', width: '33px' } },
);
